import React from 'react';
import cn from 'classnames';
import parse from 'react-html-parser';

import { genKey } from './addKey';
import crossIcon from '../images/cross-icon.svg';

export const modalStyle = {
    width: '615px',
    padding: '0',
    overflow: 'auto',
    zIndex: '10000',
    border: 'none'
};
export const modalMobileStyle = {
    height: '100vh',
    width: '100%',
    padding: '0',
    overflow: 'scroll',
    zIndex: '10000'
};

/**
 * @param {String} id - key to render correct section
 * @param {Object} contents - items to parse as modal content
 * @param {Object} styles - css styles to be applied to content
 */
export const renderModalContent = (contentId, contents, styles) =>
    contentId === 'sf-methodology' &&
    contents.map((item, index) => (
        <React.Fragment key={genKey()}>
            <span
                key={genKey()}
                className={cn('modal-content-title', {
                    'no-padding': index === 0
                })}
            >
                {item.title}
            </span>
            {/* account for content with bulleted list */}
            {item.listItems && (
                <ul>
                    {item.listItems.map((li) => <li key={genKey()}>{li}</li>)}
                </ul>
            )}
            {/* mapped this way to apply padding between each content paragraph */}
            {item.disc.map((d) => <p key={genKey()}>{parse(d)}</p>)}
            <style jsx>{styles}</style>
        </React.Fragment>
    ));

/**
 * @param {Function} onClose - on click handler for closing by button
 * @param {Object} styles  - css styling to be implemented
 */
export const renderModalCloseButton = (onClose, styles) => (
    <React.Fragment>
        <div className="close-btn-row">
            <button
                className="modal-close-btn"
                type="button"
                onClick={() => onClose()}
            >
                <img
                    className="modal-close-btn-img"
                    alt="Close"
                    src={crossIcon}
                />
            </button>
        </div>

        <style jsx>{styles}</style>
    </React.Fragment>
);
